module.exports = __webpack_public_path__ + "static/media/survey_icon_selected.0cab0b76.svg";